import { render, staticRenderFns } from "./CCheckbox.vue?vue&type=template&id=c65f2d66&scoped=true"
import script from "./CCheckbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./CCheckbox.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CCheckbox.vue?vue&type=style&index=0&id=c65f2d66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65f2d66",
  null
  
)

export default component.exports